import { createSlice } from "@reduxjs/toolkit";
import {
  deleteCategoryData,
  getActiveCategoryData,
  getCategoryData,
  undoDeleteCategoryData,
} from "./CategoryData.api";

const categoryDataSlice = createSlice({
  name: "categoryData",
  initialState: {
    categoryData: [],
    activeCategoryData: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    // GET Banner FILTER WISE DATA
    builder.addCase(getCategoryData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getCategoryData.fulfilled, (state, action) => {
      state.loading = false;
      state.categoryData = action.payload;
      state.dataLimit = action.payload?.meta?.limit || 0;
      state.currentPage = action.payload?.meta?.page || 1;
      state.totalPages = action.payload?.meta?.totalPages || 0;
      state.totalData = action.payload?.meta?.total || 0;
    });
    builder.addCase(getCategoryData.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getActiveCategoryData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getActiveCategoryData.fulfilled, (state, action) => {
      state.loading = false;
      state.activeCategoryData = action.payload;
    });
    builder.addCase(getActiveCategoryData.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteCategoryData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteCategoryData.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.categoryData.data) {
        state.categoryData.data = state.categoryData.data.filter(
          (categoryData) => {
            return categoryData._id !== deletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.categoryData.data is not an array:",
          state.categoryData.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteCategoryData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteCategoryData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteCategoryData.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.categoryData.data) {
        state.categoryData.data = state.categoryData.data.filter(
          (categoryData) => {
            return categoryData._id !== undodeletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.categoryData.data is not an array:",
          state.categoryData.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteCategoryData.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = categoryDataSlice.actions;
export default categoryDataSlice.reducer;
